import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=059ac44a&"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js&"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports